var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96924 9.0308L4.97016 9.0317C5.11641 9.17646 5.30823 9.25002 5.50002 9.25002C5.69181 9.25002 5.88363 9.17646 6.02989 9.0317L13.0313 2.03034C13.3233 1.73682 13.3233 1.26322 13.0313 0.969691L13.0303 0.968789C12.7368 0.67676 12.2628 0.677225 11.9692 0.969254L5.50003 7.43943L2.03035 3.96879C1.73682 3.67676 1.26322 3.67676 0.969698 3.96879L0.968796 3.96969C0.676767 4.26322 0.677219 4.73727 0.969247 5.03079L4.96924 9.0308ZM1.47315 4.00048C1.35425 4.00683 1.23716 4.05534 1.14602 4.14602C0.951024 4.34202 0.951024 4.65802 1.14602 4.85402L5.14602 8.85402C5.24402 8.95102 5.37202 9.00002 5.50002 9.00002C5.50906 9.00002 5.5181 8.99977 5.52713 8.99928C5.51817 8.99976 5.50921 9.00001 5.50025 9.00001C5.37225 9.00001 5.24425 8.95101 5.14625 8.85401L1.14625 4.85401C0.95125 4.65801 0.95125 4.34201 1.14625 4.14601C1.23733 4.05539 1.35432 4.00688 1.47315 4.00048ZM12.4731 1.00048C12.3542 1.00683 12.2372 1.05534 12.146 1.14602L5.50014 7.7929L5.50025 7.79301L12.1462 1.14601C12.2373 1.05539 12.3543 1.00688 12.4731 1.00048Z",
    fill: "#343741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.71fb7ebf002eea477bfbf4cc5767f487.svg";
export { ForwardRef as ReactComponent };